// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admins__Bookings__DayController from "./admins/bookings/day_controller"
application.register("admins--bookings--day", Admins__Bookings__DayController)

import Admins__Bookings__ExtraController from "./admins/bookings/extra_controller"
application.register("admins--bookings--extra", Admins__Bookings__ExtraController)

import Admins__BookingsController from "./admins/bookings_controller"
application.register("admins--bookings", Admins__BookingsController)

import Admins__Components__SearchFormController from "./admins/components/search_form_controller"
application.register("admins--components--search-form", Admins__Components__SearchFormController)

import Admins__ContentController from "./admins/content_controller"
application.register("admins--content", Admins__ContentController)

import Admins__Customers__AvatarController from "./admins/customers/avatar_controller"
application.register("admins--customers--avatar", Admins__Customers__AvatarController)

import Admins__Customers__ItemController from "./admins/customers/item_controller"
application.register("admins--customers--item", Admins__Customers__ItemController)

import Admins__CustomersController from "./admins/customers_controller"
application.register("admins--customers", Admins__CustomersController)

import Admins__Dashboards__SwitchController from "./admins/dashboards/switch_controller"
application.register("admins--dashboards--switch", Admins__Dashboards__SwitchController)

import Admins__Documents__PrintController from "./admins/documents/print_controller"
application.register("admins--documents--print", Admins__Documents__PrintController)

import Admins__ErrorsController from "./admins/errors_controller"
application.register("admins--errors", Admins__ErrorsController)

import Admins__LanguageSwitchController from "./admins/language_switch_controller"
application.register("admins--language-switch", Admins__LanguageSwitchController)

import Admins__MenueController from "./admins/menue_controller"
application.register("admins--menue", Admins__MenueController)

import Admins__Pricelists__FormController from "./admins/pricelists/form_controller"
application.register("admins--pricelists--form", Admins__Pricelists__FormController)

import Admins__Receipts__CalculatorController from "./admins/receipts/calculator_controller"
application.register("admins--receipts--calculator", Admins__Receipts__CalculatorController)

import Admins__Receipts__ExpenseController from "./admins/receipts/expense_controller"
application.register("admins--receipts--expense", Admins__Receipts__ExpenseController)

import Admins__Receipts__ExtrasController from "./admins/receipts/extras_controller"
application.register("admins--receipts--extras", Admins__Receipts__ExtrasController)

import Admins__Receipts__IncomeController from "./admins/receipts/income_controller"
application.register("admins--receipts--income", Admins__Receipts__IncomeController)

import Admins__Receipts__SwitchContentController from "./admins/receipts/switch_content_controller"
application.register("admins--receipts--switch-content", Admins__Receipts__SwitchContentController)

import Admins__ReceiptsController from "./admins/receipts_controller"
application.register("admins--receipts", Admins__ReceiptsController)

import Admins__RedirectController from "./admins/redirect_controller"
application.register("admins--redirect", Admins__RedirectController)

import Admins__Services__ItemController from "./admins/services/item_controller"
application.register("admins--services--item", Admins__Services__ItemController)

import Admins__Services__SwitchController from "./admins/services/switch_controller"
application.register("admins--services--switch", Admins__Services__SwitchController)

import Admins__ServicesController from "./admins/services_controller"
application.register("admins--services", Admins__ServicesController)

import Application__FormController from "./application/form_controller"
application.register("application--form", Application__FormController)

import Application__RedirectController from "./application/redirect_controller"
application.register("application--redirect", Application__RedirectController)

import Application__ResponsiveController from "./application/responsive_controller"
application.register("application--responsive", Application__ResponsiveController)

import Components__AvatarController from "./components/avatar_controller"
application.register("components--avatar", Components__AvatarController)

import Components__CalendarController from "./components/calendar_controller"
application.register("components--calendar", Components__CalendarController)

import Components__CalendarModalController from "./components/calendar_modal_controller"
application.register("components--calendar-modal", Components__CalendarModalController)

import Components__ConfirmMessageController from "./components/confirm_message_controller"
application.register("components--confirm-message", Components__ConfirmMessageController)

import Components__FlashMessagesController from "./components/flash_messages_controller"
application.register("components--flash-messages", Components__FlashMessagesController)

import Components__Forms__ArrayFieldController from "./components/forms/array_field_controller"
application.register("components--forms--array-field", Components__Forms__ArrayFieldController)

import Components__Forms__MatchListItemController from "./components/forms/match_list_item_controller"
application.register("components--forms--match-list-item", Components__Forms__MatchListItemController)

import Components__SearchBarController from "./components/search_bar_controller"
application.register("components--search-bar", Components__SearchBarController)

import Pages__CookiesController from "./pages/cookies_controller"
application.register("pages--cookies", Pages__CookiesController)

import Pages__IndexController from "./pages/index_controller"
application.register("pages--index", Pages__IndexController)

import Pages__ModalsController from "./pages/modals_controller"
application.register("pages--modals", Pages__ModalsController)

import Users__MenueController from "./users/menue_controller"
application.register("users--menue", Users__MenueController)

import Users__NavigationController from "./users/navigation_controller"
application.register("users--navigation", Users__NavigationController)
